class Trustpilot extends HTMLElement {
  constructor() {
    super();
    if (document.querySelectorAll('.footer-bottom-pane-wrap trustpilot-summary').length < 2) {
      this.shouldDefinePlacement = JSON.parse(this.dataset.definePlacement);
      this.isMobile = window.innerWidth < 1025 ? true : false;
      this.definePlacement();
      this.buildSelecotrs();
      this.fetchData();
    }
  }

  static getElementName() {
    return 'trustpilot-summary';
  }

  get companyName() {
    return 'www.perfumania.com';
  }

  definePlacement() {
    const desktopTpWrapper = document.querySelector(
      'footer.footer-wrapper .footer-bottom-pane-wrap'
    );
    if (!this.shouldDefinePlacement || this.isMobile || !desktopTpWrapper) return;

    desktopTpWrapper.prepend(this);
  }

  buildSelecotrs() {
    this.tpScore = this.querySelector('[data-tp-score]');
    this.tpReview = this.querySelector('[data-tp-reviews]');
    // this.srOnly = this.querySelector('.visually-hidden');
    this.globalTpSrOnly = document.querySelectorAll('[data-tp-sr-only]');
  }

  async fetchData() {
    try {
      const resp = await fetch(
        `https://api.trustpilot.com/v1/business-units/find?name=${this.companyName}`,
        {
          headers: {
            apikey: 'Bma1O3hzcwubG63AcMXW8wTysjZoFllM',
            'Content-Type': 'application/json',
          },
        }
      );

      const data = await resp.json();
      this.data = data;
      this.render();
      this.updateGlobalSrOnlyText();
    } catch (err) {
      console.log(err);
    }
  }

  updateGlobalSrOnlyText() {
    if (!this.data) return;

    const srText = `TrustScore ${this.data.score.trustScore} ${this.data.numberOfReviews.total} reviews`;
    const reviewText =
      'TrustScore ' +
      this.data.score.trustScore +
      ' stars out of 5 stars rating on Trustpilot. Based on ' +
      this.data.numberOfReviews.total +
      ' reviews Opens in a new window ';
    this.globalTpSrOnly = document.querySelectorAll('[data-tp-sr-only]');
    this.globalTpSrOnly.forEach((elem) => {
      elem.textContent = reviewText;
      const parentLink = elem.closest('a');
      if (parentLink) {
        parentLink.setAttribute('aria-label', reviewText);
        // parentLink.setAttribute('aria-label', srText);
        // parentLink.setAttribute('aria-description', reviewText);
      }
    });
  }

  render() {
    if (!this.data) return;
    if (!this.data.status || this.data.status !== 'active') return;
    this.tpScore.innerHTML = 'TrustScore <strong>' + this.data.score.trustScore + '</strong>';
    this.tpReview.innerHTML = '<strong>' + this.data.numberOfReviews.total + '</strong> reviews';

    const srText = `TrustScore ${this.data.score.trustScore} ${this.data.numberOfReviews.total} reviews`;
    const reviewText =
      'TrustScore ' +
      this.data.score.trustScore +
      ' stars out of 5 stars rating on Trustpilot. Based on ' +
      this.data.numberOfReviews.total +
      ' reviews Opens in a new window ';
    const link = this.querySelector('a');
    link.setAttribute('aria-label', reviewText);
    // link.setAttribute('aria-label', srText);
    // link.setAttribute('aria-description', reviewText);
  }
}

// if(!customElements.get(Trustpilot.getElementName()))
customElements.define(Trustpilot.getElementName(), Trustpilot);
